import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import GoTrueApi from './GoTrueApi';
import { isBrowser, getParameterByName, uuid, setItemAsync, removeItemAsync, getItemSynchronously, getItemAsync } from './lib/helpers';
import { GOTRUE_URL, DEFAULT_HEADERS, STORAGE_KEY, EXPIRY_MARGIN, NETWORK_FAILURE } from './lib/constants';
import { polyfillGlobalThis } from './lib/polyfills';
polyfillGlobalThis(); // Make "globalThis" available

var DEFAULT_OPTIONS = {
  url: GOTRUE_URL,
  autoRefreshToken: true,
  persistSession: true,
  detectSessionInUrl: true,
  multiTab: true,
  headers: DEFAULT_HEADERS
};

var GoTrueClient = /*#__PURE__*/function () {
  /**
   * Create a new client for use in the browser.
   * @param options.url The URL of the GoTrue server.
   * @param options.headers Any additional headers to send to the GoTrue server.
   * @param options.detectSessionInUrl Set to "true" if you want to automatically detects OAuth grants in the URL and signs in the user.
   * @param options.autoRefreshToken Set to "true" if you want to automatically refresh the token before expiring.
   * @param options.persistSession Set to "true" if you want to automatically save the user session into local storage.
   * @param options.localStorage Provide your own local storage implementation to use instead of the browser's local storage.
   * @param options.multiTab Set to "false" if you want to disable multi-tab/window events.
   * @param options.cookieOptions
   * @param options.fetch A custom fetch implementation.
   */
  function GoTrueClient(options) {
    _classCallCheck(this, GoTrueClient);

    this.stateChangeEmitters = new Map();
    this.networkRetries = 0;
    var settings = Object.assign(Object.assign({}, DEFAULT_OPTIONS), options);
    this.currentUser = null;
    this.currentSession = null;
    this.autoRefreshToken = settings.autoRefreshToken;
    this.persistSession = settings.persistSession;
    this.multiTab = settings.multiTab;
    this.localStorage = settings.localStorage || globalThis.localStorage;
    this.api = new GoTrueApi({
      url: settings.url,
      headers: settings.headers,
      cookieOptions: settings.cookieOptions,
      fetch: settings.fetch
    });

    this._recoverSession();

    this._recoverAndRefresh();

    this._listenForMultiTabEvents();

    this._handleVisibilityChange();

    if (settings.detectSessionInUrl && isBrowser() && !!getParameterByName('access_token')) {
      // Handle the OAuth redirect
      this.getSessionFromUrl({
        storeSession: true
      }).then(function (_ref) {
        var error = _ref.error;

        if (error) {
          throw new Error('Error getting session from URL.');
        }
      });
    }
  }
  /**
   * Creates a new user.
   * @type UserCredentials
   * @param email The user's email address.
   * @param password The user's password.
   * @param phone The user's phone number.
   * @param redirectTo The redirect URL attached to the signup confirmation link. Does not redirect the user if it's a mobile signup.
   * @param data Optional user metadata.
   */


  _createClass(GoTrueClient, [{
    key: "signUp",
    value: function signUp(_ref2) {
      var email = _ref2.email,
          password = _ref2.password,
          phone = _ref2.phone;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _ref3, data, error, session, user;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                this._removeSession();

                if (!(phone && password)) {
                  _context.next = 8;
                  break;
                }

                _context.next = 5;
                return this.api.signUpWithPhone(phone, password, {
                  data: options.data,
                  captchaToken: options.captchaToken
                });

              case 5:
                _context.t0 = _context.sent;
                _context.next = 11;
                break;

              case 8:
                _context.next = 10;
                return this.api.signUpWithEmail(email, password, {
                  redirectTo: options.redirectTo,
                  data: options.data,
                  captchaToken: options.captchaToken
                });

              case 10:
                _context.t0 = _context.sent;

              case 11:
                _ref3 = _context.t0;
                data = _ref3.data;
                error = _ref3.error;

                if (!error) {
                  _context.next = 16;
                  break;
                }

                throw error;

              case 16:
                if (data) {
                  _context.next = 18;
                  break;
                }

                throw 'An error occurred on sign up.';

              case 18:
                session = null;
                user = null;

                if (data.access_token) {
                  session = data;
                  user = session.user;

                  this._saveSession(session);

                  this._notifyAllSubscribers('SIGNED_IN');
                }

                if (data.id) {
                  user = data;
                }

                return _context.abrupt("return", {
                  user: user,
                  session: session,
                  error: null
                });

              case 25:
                _context.prev = 25;
                _context.t1 = _context["catch"](0);
                return _context.abrupt("return", {
                  user: null,
                  session: null,
                  error: _context.t1
                });

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 25]]);
      }));
    }
    /**
     * Log in an existing user, or login via a third-party provider.
     * @type UserCredentials
     * @param email The user's email address.
     * @param phone The user's phone number.
     * @param password The user's password.
     * @param refreshToken A valid refresh token that was returned on login.
     * @param provider One of the providers supported by GoTrue.
     * @param redirectTo A URL to send the user to after they are confirmed (OAuth logins only).
     * @param shouldCreateUser A boolean flag to indicate whether to automatically create a user on magiclink / otp sign-ins if the user doesn't exist. Defaults to true.
     * @param scopes A space-separated list of scopes granted to the OAuth application.
     */

  }, {
    key: "signIn",
    value: function signIn(_ref4) {
      var email = _ref4.email,
          phone = _ref4.phone,
          password = _ref4.password,
          refreshToken = _ref4.refreshToken,
          provider = _ref4.provider,
          oidc = _ref4.oidc;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _yield$this$api$sendM, error, _yield$this$api$sendM2, _error, _yield$this$_callRefr, _error2;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                this._removeSession();

                if (!(email && !password)) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 5;
                return this.api.sendMagicLinkEmail(email, {
                  redirectTo: options.redirectTo,
                  shouldCreateUser: options.shouldCreateUser,
                  captchaToken: options.captchaToken
                });

              case 5:
                _yield$this$api$sendM = _context2.sent;
                error = _yield$this$api$sendM.error;
                return _context2.abrupt("return", {
                  user: null,
                  session: null,
                  error: error
                });

              case 8:
                if (!(email && password)) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return", this._handleEmailSignIn(email, password, {
                  redirectTo: options.redirectTo,
                  captchaToken: options.captchaToken
                }));

              case 10:
                if (!(phone && !password)) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 13;
                return this.api.sendMobileOTP(phone, {
                  shouldCreateUser: options.shouldCreateUser,
                  captchaToken: options.captchaToken
                });

              case 13:
                _yield$this$api$sendM2 = _context2.sent;
                _error = _yield$this$api$sendM2.error;
                return _context2.abrupt("return", {
                  user: null,
                  session: null,
                  error: _error
                });

              case 16:
                if (!(phone && password)) {
                  _context2.next = 18;
                  break;
                }

                return _context2.abrupt("return", this._handlePhoneSignIn(phone, password));

              case 18:
                if (!refreshToken) {
                  _context2.next = 26;
                  break;
                }

                _context2.next = 21;
                return this._callRefreshToken(refreshToken);

              case 21:
                _yield$this$_callRefr = _context2.sent;
                _error2 = _yield$this$_callRefr.error;

                if (!_error2) {
                  _context2.next = 25;
                  break;
                }

                throw _error2;

              case 25:
                return _context2.abrupt("return", {
                  user: this.currentUser,
                  session: this.currentSession,
                  error: null
                });

              case 26:
                if (!provider) {
                  _context2.next = 28;
                  break;
                }

                return _context2.abrupt("return", this._handleProviderSignIn(provider, {
                  redirectTo: options.redirectTo,
                  scopes: options.scopes,
                  queryParams: options.queryParams
                }));

              case 28:
                if (!oidc) {
                  _context2.next = 30;
                  break;
                }

                return _context2.abrupt("return", this._handleOpenIDConnectSignIn(oidc));

              case 30:
                throw new Error("You must provide either an email, phone number, a third-party provider or OpenID Connect.");

              case 33:
                _context2.prev = 33;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", {
                  user: null,
                  session: null,
                  error: _context2.t0
                });

              case 36:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 33]]);
      }));
    }
    /**
     * Log in a user given a User supplied OTP received via mobile.
     * @param email The user's email address.
     * @param phone The user's phone number.
     * @param token The user's password.
     * @param type The user's verification type.
     * @param redirectTo A URL or mobile address to send the user to after they are confirmed.
     */

  }, {
    key: "verifyOTP",
    value: function verifyOTP(params) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _yield$this$api$verif, data, error, session, user;

        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                this._removeSession();

                _context3.next = 4;
                return this.api.verifyOTP(params, options);

              case 4:
                _yield$this$api$verif = _context3.sent;
                data = _yield$this$api$verif.data;
                error = _yield$this$api$verif.error;

                if (!error) {
                  _context3.next = 9;
                  break;
                }

                throw error;

              case 9:
                if (data) {
                  _context3.next = 11;
                  break;
                }

                throw 'An error occurred on token verification.';

              case 11:
                session = null;
                user = null;

                if (data.access_token) {
                  session = data;
                  user = session.user;

                  this._saveSession(session);

                  this._notifyAllSubscribers('SIGNED_IN');
                }

                if (data.id) {
                  user = data;
                }

                return _context3.abrupt("return", {
                  user: user,
                  session: session,
                  error: null
                });

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", {
                  user: null,
                  session: null,
                  error: _context3.t0
                });

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 18]]);
      }));
    }
    /**
     * Inside a browser context, `user()` will return the user data, if there is a logged in user.
     *
     * For server-side management, you can get a user through `auth.api.getUserByCookie()`
     */

  }, {
    key: "user",
    value: function user() {
      return this.currentUser;
    }
    /**
     * Returns the session data, if there is an active session.
     */

  }, {
    key: "session",
    value: function session() {
      return this.currentSession;
    }
    /**
     * Force refreshes the session including the user data in case it was updated in a different session.
     */

  }, {
    key: "refreshSession",
    value: function refreshSession() {
      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _yield$this$_callRefr2, error;

        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                if ((_a = this.currentSession) === null || _a === void 0 ? void 0 : _a.access_token) {
                  _context4.next = 3;
                  break;
                }

                throw new Error('Not logged in.');

              case 3:
                _context4.next = 5;
                return this._callRefreshToken();

              case 5:
                _yield$this$_callRefr2 = _context4.sent;
                error = _yield$this$_callRefr2.error;

                if (!error) {
                  _context4.next = 9;
                  break;
                }

                throw error;

              case 9:
                return _context4.abrupt("return", {
                  data: this.currentSession,
                  user: this.currentUser,
                  error: null
                });

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", {
                  data: null,
                  user: null,
                  error: _context4.t0
                });

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 12]]);
      }));
    }
    /**
     * Updates user data, if there is a logged in user.
     */

  }, {
    key: "update",
    value: function update(attributes) {
      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _yield$this$api$updat, user, error, session;

        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                if ((_a = this.currentSession) === null || _a === void 0 ? void 0 : _a.access_token) {
                  _context5.next = 3;
                  break;
                }

                throw new Error('Not logged in.');

              case 3:
                _context5.next = 5;
                return this.api.updateUser(this.currentSession.access_token, attributes);

              case 5:
                _yield$this$api$updat = _context5.sent;
                user = _yield$this$api$updat.user;
                error = _yield$this$api$updat.error;

                if (!error) {
                  _context5.next = 10;
                  break;
                }

                throw error;

              case 10:
                if (user) {
                  _context5.next = 12;
                  break;
                }

                throw Error('Invalid user data.');

              case 12:
                session = Object.assign(Object.assign({}, this.currentSession), {
                  user: user
                });

                this._saveSession(session);

                this._notifyAllSubscribers('USER_UPDATED');

                return _context5.abrupt("return", {
                  data: user,
                  user: user,
                  error: null
                });

              case 18:
                _context5.prev = 18;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", {
                  data: null,
                  user: null,
                  error: _context5.t0
                });

              case 21:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 18]]);
      }));
    }
    /**
     * Sets the session data from refresh_token and returns current Session and Error
     * @param refresh_token a JWT token
     */

  }, {
    key: "setSession",
    value: function setSession(refresh_token) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _yield$this$api$refre, data, error;

        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                if (refresh_token) {
                  _context6.next = 3;
                  break;
                }

                throw new Error('No current session.');

              case 3:
                _context6.next = 5;
                return this.api.refreshAccessToken(refresh_token);

              case 5:
                _yield$this$api$refre = _context6.sent;
                data = _yield$this$api$refre.data;
                error = _yield$this$api$refre.error;

                if (!error) {
                  _context6.next = 10;
                  break;
                }

                return _context6.abrupt("return", {
                  session: null,
                  error: error
                });

              case 10:
                this._saveSession(data);

                this._notifyAllSubscribers('SIGNED_IN');

                return _context6.abrupt("return", {
                  session: data,
                  error: null
                });

              case 15:
                _context6.prev = 15;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", {
                  error: _context6.t0,
                  session: null
                });

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 15]]);
      }));
    }
    /**
     * Overrides the JWT on the current client. The JWT will then be sent in all subsequent network requests.
     * @param access_token a jwt access token
     */

  }, {
    key: "setAuth",
    value: function setAuth(access_token) {
      this.currentSession = Object.assign(Object.assign({}, this.currentSession), {
        access_token: access_token,
        token_type: 'bearer',
        user: this.user()
      });

      this._notifyAllSubscribers('TOKEN_REFRESHED');

      return this.currentSession;
    }
    /**
     * Gets the session data from a URL string
     * @param options.storeSession Optionally store the session in the browser
     */

  }, {
    key: "getSessionFromUrl",
    value: function getSessionFromUrl(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var error_description, provider_token, access_token, expires_in, refresh_token, token_type, timeNow, expires_at, _yield$this$api$getUs, user, error, session, recoveryMode;

        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                if (isBrowser()) {
                  _context7.next = 3;
                  break;
                }

                throw new Error('No browser detected.');

              case 3:
                error_description = getParameterByName('error_description');

                if (!error_description) {
                  _context7.next = 6;
                  break;
                }

                throw new Error(error_description);

              case 6:
                provider_token = getParameterByName('provider_token');
                access_token = getParameterByName('access_token');

                if (access_token) {
                  _context7.next = 10;
                  break;
                }

                throw new Error('No access_token detected.');

              case 10:
                expires_in = getParameterByName('expires_in');

                if (expires_in) {
                  _context7.next = 13;
                  break;
                }

                throw new Error('No expires_in detected.');

              case 13:
                refresh_token = getParameterByName('refresh_token');

                if (refresh_token) {
                  _context7.next = 16;
                  break;
                }

                throw new Error('No refresh_token detected.');

              case 16:
                token_type = getParameterByName('token_type');

                if (token_type) {
                  _context7.next = 19;
                  break;
                }

                throw new Error('No token_type detected.');

              case 19:
                timeNow = Math.round(Date.now() / 1000);
                expires_at = timeNow + parseInt(expires_in);
                _context7.next = 23;
                return this.api.getUser(access_token);

              case 23:
                _yield$this$api$getUs = _context7.sent;
                user = _yield$this$api$getUs.user;
                error = _yield$this$api$getUs.error;

                if (!error) {
                  _context7.next = 28;
                  break;
                }

                throw error;

              case 28:
                session = {
                  provider_token: provider_token,
                  access_token: access_token,
                  expires_in: parseInt(expires_in),
                  expires_at: expires_at,
                  refresh_token: refresh_token,
                  token_type: token_type,
                  user: user
                };

                if (options === null || options === void 0 ? void 0 : options.storeSession) {
                  this._saveSession(session);

                  recoveryMode = getParameterByName('type');

                  this._notifyAllSubscribers('SIGNED_IN');

                  if (recoveryMode === 'recovery') {
                    this._notifyAllSubscribers('PASSWORD_RECOVERY');
                  }
                } // Remove tokens from URL


                window.location.hash = '';
                return _context7.abrupt("return", {
                  data: session,
                  error: null
                });

              case 34:
                _context7.prev = 34;
                _context7.t0 = _context7["catch"](0);
                return _context7.abrupt("return", {
                  data: null,
                  error: _context7.t0
                });

              case 37:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 34]]);
      }));
    }
    /**
     * Inside a browser context, `signOut()` will remove the logged in user from the browser session
     * and log them out - removing all items from localstorage and then trigger a "SIGNED_OUT" event.
     *
     * For server-side management, you can revoke all refresh tokens for a user by passing a user's JWT through to `auth.api.signOut(JWT: string)`. There is no way to revoke a user's session JWT before it automatically expires
     */

  }, {
    key: "signOut",
    value: function signOut() {
      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var accessToken, _yield$this$api$signO, error;

        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                accessToken = (_a = this.currentSession) === null || _a === void 0 ? void 0 : _a.access_token;

                this._removeSession();

                this._notifyAllSubscribers('SIGNED_OUT');

                if (!accessToken) {
                  _context8.next = 10;
                  break;
                }

                _context8.next = 6;
                return this.api.signOut(accessToken);

              case 6:
                _yield$this$api$signO = _context8.sent;
                error = _yield$this$api$signO.error;

                if (!error) {
                  _context8.next = 10;
                  break;
                }

                return _context8.abrupt("return", {
                  error: error
                });

              case 10:
                return _context8.abrupt("return", {
                  error: null
                });

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
    /**
     * Receive a notification every time an auth event happens.
     * @returns {Subscription} A subscription object which can be used to unsubscribe itself.
     */

  }, {
    key: "onAuthStateChange",
    value: function onAuthStateChange(callback) {
      var _this = this;

      try {
        var id = uuid();
        var subscription = {
          id: id,
          callback: callback,
          unsubscribe: function unsubscribe() {
            _this.stateChangeEmitters.delete(id);
          }
        };
        this.stateChangeEmitters.set(id, subscription);
        return {
          data: subscription,
          error: null
        };
      } catch (e) {
        return {
          data: null,
          error: e
        };
      }
    }
  }, {
    key: "_handleEmailSignIn",
    value: function _handleEmailSignIn(email, password) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var _a, _b;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _yield$this$api$signI, data, error;

        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return this.api.signInWithEmail(email, password, {
                  redirectTo: options.redirectTo,
                  captchaToken: options.captchaToken
                });

              case 3:
                _yield$this$api$signI = _context9.sent;
                data = _yield$this$api$signI.data;
                error = _yield$this$api$signI.error;

                if (!(error || !data)) {
                  _context9.next = 8;
                  break;
                }

                return _context9.abrupt("return", {
                  data: null,
                  user: null,
                  session: null,
                  error: error
                });

              case 8:
                if (((_a = data === null || data === void 0 ? void 0 : data.user) === null || _a === void 0 ? void 0 : _a.confirmed_at) || ((_b = data === null || data === void 0 ? void 0 : data.user) === null || _b === void 0 ? void 0 : _b.email_confirmed_at)) {
                  this._saveSession(data);

                  this._notifyAllSubscribers('SIGNED_IN');
                }

                return _context9.abrupt("return", {
                  data: data,
                  user: data.user,
                  session: data,
                  error: null
                });

              case 12:
                _context9.prev = 12;
                _context9.t0 = _context9["catch"](0);
                return _context9.abrupt("return", {
                  data: null,
                  user: null,
                  session: null,
                  error: _context9.t0
                });

              case 15:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 12]]);
      }));
    }
  }, {
    key: "_handlePhoneSignIn",
    value: function _handlePhoneSignIn(phone, password) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _yield$this$api$signI2, data, error;

        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return this.api.signInWithPhone(phone, password, options);

              case 3:
                _yield$this$api$signI2 = _context10.sent;
                data = _yield$this$api$signI2.data;
                error = _yield$this$api$signI2.error;

                if (!(error || !data)) {
                  _context10.next = 8;
                  break;
                }

                return _context10.abrupt("return", {
                  data: null,
                  user: null,
                  session: null,
                  error: error
                });

              case 8:
                if ((_a = data === null || data === void 0 ? void 0 : data.user) === null || _a === void 0 ? void 0 : _a.phone_confirmed_at) {
                  this._saveSession(data);

                  this._notifyAllSubscribers('SIGNED_IN');
                }

                return _context10.abrupt("return", {
                  data: data,
                  user: data.user,
                  session: data,
                  error: null
                });

              case 12:
                _context10.prev = 12;
                _context10.t0 = _context10["catch"](0);
                return _context10.abrupt("return", {
                  data: null,
                  user: null,
                  session: null,
                  error: _context10.t0
                });

              case 15:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 12]]);
      }));
    }
  }, {
    key: "_handleProviderSignIn",
    value: function _handleProviderSignIn(provider) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var url = this.api.getUrlForProvider(provider, {
        redirectTo: options.redirectTo,
        scopes: options.scopes,
        queryParams: options.queryParams
      });

      try {
        // try to open on the browser
        if (isBrowser()) {
          window.location.href = url;
        }

        return {
          provider: provider,
          url: url,
          data: null,
          session: null,
          user: null,
          error: null
        };
      } catch (e) {
        // fallback to returning the URL
        if (url) return {
          provider: provider,
          url: url,
          data: null,
          session: null,
          user: null,
          error: null
        };
        return {
          data: null,
          user: null,
          session: null,
          error: e
        };
      }
    }
  }, {
    key: "_handleOpenIDConnectSignIn",
    value: function _handleOpenIDConnectSignIn(_ref5) {
      var id_token = _ref5.id_token,
          nonce = _ref5.nonce,
          client_id = _ref5.client_id,
          issuer = _ref5.issuer,
          provider = _ref5.provider;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _yield$this$api$signI3, data, error;

        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!(id_token && nonce && (client_id && issuer || provider))) {
                  _context11.next = 17;
                  break;
                }

                _context11.prev = 1;
                _context11.next = 4;
                return this.api.signInWithOpenIDConnect({
                  id_token: id_token,
                  nonce: nonce,
                  client_id: client_id,
                  issuer: issuer,
                  provider: provider
                });

              case 4:
                _yield$this$api$signI3 = _context11.sent;
                data = _yield$this$api$signI3.data;
                error = _yield$this$api$signI3.error;

                if (!(error || !data)) {
                  _context11.next = 9;
                  break;
                }

                return _context11.abrupt("return", {
                  user: null,
                  session: null,
                  error: error
                });

              case 9:
                this._saveSession(data);

                this._notifyAllSubscribers('SIGNED_IN');

                return _context11.abrupt("return", {
                  user: data.user,
                  session: data,
                  error: null
                });

              case 14:
                _context11.prev = 14;
                _context11.t0 = _context11["catch"](1);
                return _context11.abrupt("return", {
                  user: null,
                  session: null,
                  error: _context11.t0
                });

              case 17:
                throw new Error("You must provide a OpenID Connect provider with your id token and nonce.");

              case 18:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[1, 14]]);
      }));
    }
    /**
     * Attempts to get the session from LocalStorage
     * Note: this should never be async (even for React Native), as we need it to return immediately in the constructor.
     */

  }, {
    key: "_recoverSession",
    value: function _recoverSession() {
      try {
        var data = getItemSynchronously(this.localStorage, STORAGE_KEY);
        if (!data) return null;
        var currentSession = data.currentSession,
            expiresAt = data.expiresAt;
        var timeNow = Math.round(Date.now() / 1000);

        if (expiresAt >= timeNow + EXPIRY_MARGIN && (currentSession === null || currentSession === void 0 ? void 0 : currentSession.user)) {
          this._saveSession(currentSession);

          this._notifyAllSubscribers('SIGNED_IN');
        }
      } catch (error) {
        console.log('error', error);
      }
    }
    /**
     * Recovers the session from LocalStorage and refreshes
     * Note: this method is async to accommodate for AsyncStorage e.g. in React native.
     */

  }, {
    key: "_recoverAndRefresh",
    value: function _recoverAndRefresh() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _this2 = this;

        var data, currentSession, expiresAt, timeNow, _yield$this$_callRefr3, error;

        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                _context12.next = 3;
                return getItemAsync(this.localStorage, STORAGE_KEY);

              case 3:
                data = _context12.sent;

                if (data) {
                  _context12.next = 6;
                  break;
                }

                return _context12.abrupt("return", null);

              case 6:
                currentSession = data.currentSession, expiresAt = data.expiresAt;
                timeNow = Math.round(Date.now() / 1000);

                if (!(expiresAt < timeNow + EXPIRY_MARGIN)) {
                  _context12.next = 29;
                  break;
                }

                if (!(this.autoRefreshToken && currentSession.refresh_token)) {
                  _context12.next = 26;
                  break;
                }

                this.networkRetries++;
                _context12.next = 13;
                return this._callRefreshToken(currentSession.refresh_token);

              case 13:
                _yield$this$_callRefr3 = _context12.sent;
                error = _yield$this$_callRefr3.error;

                if (!error) {
                  _context12.next = 23;
                  break;
                }

                console.log(error.message);

                if (!(error.message === NETWORK_FAILURE.ERROR_MESSAGE && this.networkRetries < NETWORK_FAILURE.MAX_RETRIES)) {
                  _context12.next = 21;
                  break;
                }

                if (this.refreshTokenTimer) clearTimeout(this.refreshTokenTimer);
                this.refreshTokenTimer = setTimeout(function () {
                  return _this2._recoverAndRefresh();
                }, Math.pow(NETWORK_FAILURE.RETRY_INTERVAL, this.networkRetries) * 100 // exponential backoff
                );
                return _context12.abrupt("return");

              case 21:
                _context12.next = 23;
                return this._removeSession();

              case 23:
                this.networkRetries = 0;
                _context12.next = 27;
                break;

              case 26:
                this._removeSession();

              case 27:
                _context12.next = 30;
                break;

              case 29:
                if (!currentSession) {
                  console.log('Current session is missing data.');

                  this._removeSession();
                } else {
                  // should be handled on _recoverSession method already
                  // But we still need the code here to accommodate for AsyncStorage e.g. in React native
                  this._saveSession(currentSession);

                  this._notifyAllSubscribers('SIGNED_IN');
                }

              case 30:
                _context12.next = 36;
                break;

              case 32:
                _context12.prev = 32;
                _context12.t0 = _context12["catch"](0);
                console.error(_context12.t0);
                return _context12.abrupt("return", null);

              case 36:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 32]]);
      }));
    }
  }, {
    key: "_callRefreshToken",
    value: function _callRefreshToken(refresh_token) {
      var _a;

      if (refresh_token === void 0) {
        refresh_token = (_a = this.currentSession) === null || _a === void 0 ? void 0 : _a.refresh_token;
      }

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _yield$this$api$refre2, data, error;

        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;

                if (refresh_token) {
                  _context13.next = 3;
                  break;
                }

                throw new Error('No current session.');

              case 3:
                _context13.next = 5;
                return this.api.refreshAccessToken(refresh_token);

              case 5:
                _yield$this$api$refre2 = _context13.sent;
                data = _yield$this$api$refre2.data;
                error = _yield$this$api$refre2.error;

                if (!error) {
                  _context13.next = 10;
                  break;
                }

                throw error;

              case 10:
                if (data) {
                  _context13.next = 12;
                  break;
                }

                throw Error('Invalid session data.');

              case 12:
                this._saveSession(data);

                this._notifyAllSubscribers('TOKEN_REFRESHED');

                this._notifyAllSubscribers('SIGNED_IN');

                return _context13.abrupt("return", {
                  data: data,
                  error: null
                });

              case 18:
                _context13.prev = 18;
                _context13.t0 = _context13["catch"](0);
                return _context13.abrupt("return", {
                  data: null,
                  error: _context13.t0
                });

              case 21:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[0, 18]]);
      }));
    }
  }, {
    key: "_notifyAllSubscribers",
    value: function _notifyAllSubscribers(event) {
      var _this3 = this;

      this.stateChangeEmitters.forEach(function (x) {
        return x.callback(event, _this3.currentSession);
      });
    }
    /**
     * set currentSession and currentUser
     * process to _startAutoRefreshToken if possible
     */

  }, {
    key: "_saveSession",
    value: function _saveSession(session) {
      this.currentSession = session;
      this.currentUser = session.user;
      var expiresAt = session.expires_at;

      if (expiresAt) {
        var timeNow = Math.round(Date.now() / 1000);
        var expiresIn = expiresAt - timeNow;
        var refreshDurationBeforeExpires = expiresIn > EXPIRY_MARGIN ? EXPIRY_MARGIN : 0.5;

        this._startAutoRefreshToken((expiresIn - refreshDurationBeforeExpires) * 1000);
      } // Do we need any extra check before persist session
      // access_token or user ?


      if (this.persistSession && session.expires_at) {
        this._persistSession(this.currentSession);
      }
    }
  }, {
    key: "_persistSession",
    value: function _persistSession(currentSession) {
      var data = {
        currentSession: currentSession,
        expiresAt: currentSession.expires_at
      };
      setItemAsync(this.localStorage, STORAGE_KEY, data);
    }
  }, {
    key: "_removeSession",
    value: function _removeSession() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                this.currentSession = null;
                this.currentUser = null;
                if (this.refreshTokenTimer) clearTimeout(this.refreshTokenTimer);
                removeItemAsync(this.localStorage, STORAGE_KEY);

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }
    /**
     * Clear and re-create refresh token timer
     * @param value time intervals in milliseconds
     */

  }, {
    key: "_startAutoRefreshToken",
    value: function _startAutoRefreshToken(value) {
      var _this4 = this;

      if (this.refreshTokenTimer) clearTimeout(this.refreshTokenTimer);
      if (value <= 0 || !this.autoRefreshToken) return;
      this.refreshTokenTimer = setTimeout(function () {
        return __awaiter(_this4, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
          var _yield$this$_callRefr4, error;

          return _regeneratorRuntime().wrap(function _callee15$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  this.networkRetries++;
                  _context15.next = 3;
                  return this._callRefreshToken();

                case 3:
                  _yield$this$_callRefr4 = _context15.sent;
                  error = _yield$this$_callRefr4.error;
                  if (!error) this.networkRetries = 0;
                  if ((error === null || error === void 0 ? void 0 : error.message) === NETWORK_FAILURE.ERROR_MESSAGE && this.networkRetries < NETWORK_FAILURE.MAX_RETRIES) this._startAutoRefreshToken(Math.pow(NETWORK_FAILURE.RETRY_INTERVAL, this.networkRetries) * 100); // exponential backoff

                case 7:
                case "end":
                  return _context15.stop();
              }
            }
          }, _callee15, this);
        }));
      }, value);
      if (typeof this.refreshTokenTimer.unref === 'function') this.refreshTokenTimer.unref();
    }
    /**
     * Listens for changes to LocalStorage and updates the current session.
     */

  }, {
    key: "_listenForMultiTabEvents",
    value: function _listenForMultiTabEvents() {
      var _this5 = this;

      if (!this.multiTab || !isBrowser() || !(window === null || window === void 0 ? void 0 : window.addEventListener)) {
        return false;
      }

      try {
        window === null || window === void 0 ? void 0 : window.addEventListener('storage', function (e) {
          var _a;

          if (e.key === STORAGE_KEY) {
            var newSession = JSON.parse(String(e.newValue));

            if ((_a = newSession === null || newSession === void 0 ? void 0 : newSession.currentSession) === null || _a === void 0 ? void 0 : _a.access_token) {
              _this5._saveSession(newSession.currentSession);

              _this5._notifyAllSubscribers('SIGNED_IN');
            } else {
              _this5._removeSession();

              _this5._notifyAllSubscribers('SIGNED_OUT');
            }
          }
        });
      } catch (error) {
        console.error('_listenForMultiTabEvents', error);
      }
    }
  }, {
    key: "_handleVisibilityChange",
    value: function _handleVisibilityChange() {
      var _this6 = this;

      if (!this.multiTab || !isBrowser() || !(window === null || window === void 0 ? void 0 : window.addEventListener)) {
        return false;
      }

      try {
        window === null || window === void 0 ? void 0 : window.addEventListener('visibilitychange', function () {
          if (document.visibilityState === 'visible') {
            _this6._recoverAndRefresh();
          }
        });
      } catch (error) {
        console.error('_handleVisibilityChange', error);
      }
    }
  }]);

  return GoTrueClient;
}();

export { GoTrueClient as default };